import React from 'react'
import { useSelector } from 'react-redux'
import { Badge, Button, Grid, Icon, Select, Typography } from 'gu-ui-kit'
import GridSpinner from 'components/UI/GridSpinner'
import styles from 'modules/Forms/Account/Create/account-form-creation.module.scss'
import { Link } from 'react-router-dom'
import { createPath } from 'history'
import { useTranslation } from 'react-i18next'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const AdvertiserTemplateSelector = ({ selectedId, onChange }) => {
  const { data: advertisers, loading } = useSelector((state) => state['advertisers-list'])
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const breakpoint = useBreakpoint()
  return (
    <div className={'margin-bottom-32'}>
      <Select
        optionsFilterFunction={({ label, tax_number, contract: { number } = {} }, phrase) =>
          label.toLowerCase().includes(phrase.toLowerCase()) ||
          tax_number.toLowerCase().includes(phrase.toLowerCase()) ||
          number.toLowerCase().includes(phrase.toLowerCase())
        }
        activeOptionLabelTemplate={({ label, tax_number }) => label + ' - ' + tax_number}
        mode={'filter'}
        value={'' + selectedId}
        onChange={onChange}
        label={t('services::forms.register_account.fields.advertiser_template.select.label')}
        fullWidth
        readOnly={loading}
        t={t}
        options={advertisers.map((item) => ({
          ...item,
          label: '' + item.name,
          value: '' + item.id,
        }))}
        noResultsLabel={t('common::empty_results.header')}
        helperText={
          !loading &&
          advertisers.length === 0 &&
          t('services::forms.register_account.fields.advertiser_template.empty_helper')
        }
        optionLabelTemplate={({ label, contract, type, tax_number }) => (
          <Grid
            direction={'column'}
            gap={4}
          >
            <Typography variant={'Body-15'}>{label}</Typography>
            <Grid
              gap={8}
              flexAlign={'center'}
            >
              <Badge
                bgColor={'Background-Six'}
                color={'Label-GU-Primary'}
              >
                {t(`advertisers::counterparty.type.${type}`, { context: 'short' })}
              </Badge>
              <Badge bgColor={'Background-Six'}>
                {t(`advertisers::tax_number_label`)} {tax_number}
              </Badge>
              <Typography
                color={'Label-Secondary'}
                variant={'Body-10'}
              >
                {contract?.number}
              </Typography>
            </Grid>
          </Grid>
        )}
        emptyOptionLabel={t('common::select_empty_option')}
        clearOptionLabel={t('common::select_clear_option')}
        ControlProps={{
          startAdornment: loading ? (
            <GridSpinner width={24} />
          ) : (
            <Icon
              name={'search'}
              size={'m'}
              color={'Interface-Seventh'}
            />
          ),
          endAdornment: (
            <Button
              fullWidth
              variant={'ghost'}
              size={'m'}
              link
              startIcon={
                <Icon
                  name={'plus'}
                  className={styles['filter-button__icon']}
                />
              }
              noLabel={!breakpoint.fb}
              component={Link}
              to={createPath({
                pathname: pathGen(ROUTES.ADVERTISER_NEW),
                search: `goBack=${global.location.pathname + global.location.search}`,
              })}
              className={styles['advertiser-template__add-link']}
              onClick={(e) => e.stopPropagation()}
            >
              {t('common::buttons.add')}
            </Button>
          ),
        }}
      />
    </div>
  )
}

AdvertiserTemplateSelector.propTypes = {
  selectedId: PropTypes.string,
  onChange: PropTypes.func,
}

export default AdvertiserTemplateSelector
